// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"878":"e8dec7efcdc6dc08","5048":"9411e0d4dd5d09b6"}[chunkId] + ".css";
};